"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const Avatar_1 = require("../../../util/Avatar/Avatar");
const SubscriptionAvatar_1 = require("../../../util/Avatar/SubscriptionAvatar");
const useStyles = (0, silhouette_core_1.makeStyles)(() => ({
    container: {
        display: 'flex',
    },
}));
const SubscriptionLoader = () => {
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    return ((0, jsx_runtime_1.jsx)("div", { className: classes['container'], children: [1, 2, 3].map((key) => ((0, jsx_runtime_1.jsx)(SubscriptionAvatar_1.SubscriptionAvatar, { avatar: "", avatarType: Avatar_1.AvatarType.INITIALS_AVATAR, disabled: true, subscriberName: translate('subscription-loader-loading'), displayName: true }, key))) }));
};
exports.SubscriptionLoader = SubscriptionLoader;
//# sourceMappingURL=SubscriptionLoader.js.map